import React from 'react';
import { SectionVariable } from '../types';

import { TopBar } from './TopBar';
import { Header } from './Header';
import { Hero } from './Hero';
import { Benefits } from './Benefits';
import { Plans } from './Plans';
import { Features } from './Features';
import { Marquee } from './Marquee';
import { AppSection } from './AppSection';
import { FAQ } from './FAQ';
import { Footer } from './Footer';

export interface ComponentProps {
  variables?: SectionVariable;
  name?: string;
}

/**
 * Component catalog: maps string names from settings.json to React components.
 * When adding a new component, register it here.
 */
export const componentCatalog: Record<
  string,
  React.ComponentType<ComponentProps>
> = {
  TopBar,
  Header,
  Hero,
  Benefits,
  Plans,
  Features,
  Marquee,
  AppSection,
  FAQ,
  Footer,
};
export * from './FloatingWhatsApp';
